import * as React from 'react';


type Props = {
  className?: string;
  fill?: string;
  sizePx: number;
};

// TODO - this begins to look blurred at resolutions above ~15px, but needs to be used at least once at ~24px.
/**
 * FilterIcon: a component that renders an abstract, funnel-like icon, typically used to denote filter functions in the
 * app.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const FilterIcon: React.FC<Props> = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height={props.sizePx}
    width={props.sizePx}
    viewBox='0 0 24 24'
    className={props.className}
  >
    <path d='M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' fill={props.fill} />
  </svg>
);

export default FilterIcon;
